exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-orders .item[data-v-0d6a88b4]{color:#999;line-height:.64rem}.user-orders .item[data-v-0d6a88b4],.user-orders .item>div[data-v-0d6a88b4]{display:flex;align-items:center}.user-orders .item>div[data-v-0d6a88b4]:first-child{margin-right:.533333rem}.user-orders .item .svg-icon[data-v-0d6a88b4]{font-size:.426667rem!important}.user-orders .addr[data-v-0d6a88b4]{color:#999;display:flex;line-height:.64rem}.user-orders .yxq[data-v-0d6a88b4]{display:flex}.user-orders .yxq>div[data-v-0d6a88b4]{line-height:.64rem}", ""]);

// exports
